import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { useImagesLoaded } from '../../../../hooks/useImagesLoaded';
import { COLOR_BLACK, COLOR_GIGGITY } from '../../../colors';
import { ROBOTO_SLAB, CAVEAT } from '../../../fonts';

const COPYRIGHT_YEAR = new Date().getFullYear();
const useStyles = makeStyles((theme)=> ({
    wrap: {
        flex: 1,
        boxSizing: 'border-box',
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundSize: 'cover',
        backgroundImage: 'url(./images/MarketInsights/bg-clouds.svg)',
        backgroundRepeat: 'no-repeat',
        color: COLOR_BLACK,
        position: 'relative',
        fontWeight: 500,
        fontFamily: ['"Roboto Slab"', 'serif'],
    },
    wrapInfo: {
        padding: '32px 74px 0px 74px',
        display: 'flex',
        flexDirection: 'column',
    },
    contentWrap: {
        boxSizing: 'border-box',
        textAlign: 'left',
        fontSize: '28px',
        lineHeight: '32px',
        zIndex: 2,
    },
    title: {
        fontSize: '32px',
        lineHeight: '38px',
        textAlign: 'center',
        fontWeight: 700,
    },
    subTitle: {
        fontFamily: ['Caveat'],
        fontSize: '68px',
        textAlign: 'center',
        fontWeight: 400,
        marginTop: '24px',
    },
    text: {
        marginTop: '32px',
        fontSize: '30px',
        lineHeight: '48px',
        fontWeight: 400,
        textAlign: 'center',
    },
    complianceWrap: {
        boxSizing: 'border-box',
        width: '100%',
        fontSize: '12px',
        lineHeight: '16px',
        fontFamily: ['Arial'],
        color: COLOR_GIGGITY,
        padding: '36px 32px 16px 32px',
        position: 'absolute',
        bottom: 0,
    },
    disclaimerWrap: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
    },
    copyrightText: {
        flex: 1,
    },
    disclaimerText: {
        width: '245px',
        textAlign: 'right'
    },
    lrLogo: {
        display: 'block',
        height: '14px',
    },
    logoWrapper: {
        display: 'flex',
        alignItems: 'flex-end',
        width: '180px',
    },
    realtorLogo: {
        marginLeft: '20px',
        height: '25px',
    },
    equalHousingLogo: {
        marginLeft: '20px',
        height: '25px',
    },
}));

export default function Clouds({
    templateContent = {},
    currentFrame = 1,
    onImagesLoaded = null,
}) {
    const classes = useStyles();
    const {
        hero,
        subtitle,
        text,
        photos,
        category='',
        realtor_logo_required = false,
    } = templateContent || {};
    const heroImage = (photos && photos.length) ? photos[0] : hero;

    const loadedBgs = useImagesLoaded([heroImage]);
    if(!heroImage) {
        window.isLoaded = true;
    }

    useEffect(() => {
        if(loadedBgs && !window.isLoaded) {
            if(typeof onImagesLoaded === 'function') {
                onImagesLoaded();
            } else {
                window.isLoaded = true;
            }
        }
        return ()=> {
            window.isLoaded = false;
        };
    }, [loadedBgs, onImagesLoaded]);

    return (
        <>
            <link rel="stylesheet" href={ROBOTO_SLAB} />
            <link rel="stylesheet" href={CAVEAT} />

            <div className={classes.wrap}>

                {/* Content */}
                <div className={classes.wrapInfo}>

                    <div className={classes.contentWrap}>

                        <div className={classes.title}>
                            Local Market Insight {category === 'market_stat' ? 'for' : 'from'}
                        </div>
                        
                        <div className={classes.subTitle}>
                            {subtitle}
                        </div>

                        <div className={classes.text}>
                            <span dangerouslySetInnerHTML={{__html: text}} />
                        </div>
                    </div>
                </div>

                {/* Disclaimer */}
                <div className={classes.complianceWrap}>
                    <div className={classes.disclaimerWrap}>
        
                        <div className={classes.copyrightText}>
                            <img className={classes.lrLogo} src="./images/lr-logo-disclaimer-grey-dark.svg"  alt="LR Logo" />
                            <div style={{ marginTop: '3px' }}>
                                &copy; ListReports {COPYRIGHT_YEAR}, all rights reserved
                            </div>
                        </div>

                        <div className={classes.disclaimerText}>
                            This information is from third-party sources and its accuracy cannot be guaranteed
                        </div>

                        <div className={classes.logoWrapper}>
                            {realtor_logo_required && 
                                <img src="./images/realtor-logo-grey.svg" className={classes.realtorLogo} alt="Realtor logo" />
                            }
                            <img src="./images/equal-housing-logo-grey.svg" className={classes.equalHousingLogo} alt="Equal Housing logo" />
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}
